<template>
    <div class="language-edit form-material" v-if="record">
      <h2>{{ isNewRecord ? 'Create Record' : 'Edit Record' }}</h2>
      <div class="row">
          <div class="form-group row">
            <div class="col-3">
              <label for="refCode">RefCode</label>
              <input type="text" class="form-control" id="refCode" v-model="record.Reference" required>
            </div>
             <div class="col-3" v-if="!isNewRecord || viewExtra">
                <label for="mainPassenger">Main Passenger</label>
                <input type="text" class="form-control" id="mainPassenger" v-model="record.MainPassenger" required>
             </div>
            <div class="col-2" v-if="!isNewRecord || viewExtra">
              <label for="consultant">Consultant</label>
              <input type="text" class="form-control" id="consultant" v-model="record.Consultant" required>
            </div>
            <div class="col-2" v-if="!isNewRecord || viewExtra">
              <label for="bookingAnalysis">Booking Analysis</label>
              <input type="text" class="form-control" id="bookingAnalysis" v-model="record.BookingAnalysis" required>
            </div>
            <div class="col-2" v-if="!isNewRecord || viewExtra">
              <label for="bookingAnalysis">Vamoos Id</label>
              <input type="text" class="form-control" id="VamoosId" v-model="record.VamoosId">
            </div>

          </div>
      </div>
      <div class="mb-3 sm:col-span-2" v-for="(folder, key) of attachs" :key="key">
        <div class="inline-block">
          <label :for="'file-upload-' + key" class=" cursor-pointer pb-2 border-bottom border-black uppercase font-semibold text-sm flex w-auto">
            <svg width="26" height="12" viewBox="0 0 26 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.5303 0.96967C13.2374 0.676777 12.7626 0.676777 12.4697 0.96967L7.6967 5.74264C7.40381 6.03553 7.40381 6.51041 7.6967 6.8033C7.98959 7.09619 8.46447 7.09619 8.75736 6.8033L13 2.56066L17.2426 6.8033C17.5355 7.09619 18.0104 7.09619 18.3033 6.8033C18.5962 6.51041 18.5962 6.03553 18.3033 5.74264L13.5303 0.96967ZM13.75 11.5L13.75 1.5L12.25 1.5L12.25 11.5L13.75 11.5Z" fill="#1F2326"/>
            </svg>
            Subir Archivos relacionados a {{labelAttachs[key]}}
          </label>
          <input :id="'file-upload-' + key" class="d-none" type="file" @change="uploadAttachs($event, key)" multiple />
          <div v-for="(file, i) of attachs[key].files" :key="i">
            {{file.name}}
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="btn-group" role="group">
            <button type="submit" class="btn btn-primary" @click="handleSave" :disabled="!record.Reference">Save</button>
            <button type="button" class="btn btn-secondary" @click="cancel">Exit</button>
            <!--button type="button" class="btn btn-danger" @click="deleteRecord" v-if="!isNewRecord">Delete</button-->
          </div>
        </div>
      </div>
      <br/>
      <div v-if="computedForm && computedForm.id" class="mb-3">
        <button class="btn btn-info" @click="showBookingFormModal = true">
          Ver Booking Form
        </button>
      </div>
      <div class="modal fade show" tabindex="-1" role="dialog" v-if="showBookingFormModal" style="display: block; background: rgba(0,0,0,0.5); z-index: 1050;">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Booking Form</h5>
              <button type="button" class="close btn btn-close" @click="showBookingFormModal = false" aria-label="Close">
              </button>
            </div>
            <div class="modal-body">
              <BookingForm :id="computedForm.id" />
            </div>
          </div>
        </div>
      </div>
      <section class="section mt-5">
      <h3>Attachments</h3>
      <template v-for="(folder, key) of currentAttachs" :key="key + 'att'">
        <div class="attachments-container mb-4"  v-if="folder.length">
          <h4 class="col-12">{{ labelAttachs[key] }}</h4>
          <div 
            v-for="(file, index) in folder" 
            :key="index + file.file_name" 
            class="attachment-card" 
            
          >
            <div class="file-icon absolute top-px right-px" @click="deleteFile(file.key, key)">
              <i class="x ">x</i>
            </div>
            <div class="file-icon">
              <i class="fas fa-file"></i>
            </div>
            <div class="file-name" @click="downloadFile(file.key, file.file_name.split('.')[0])">
              {{ file.file_name }} ({{ file.date }})
            </div>
          </div>
        </div>
      </template>
    </section>
    </div>
    
  </template>
  
  <script>
  const api = window.api;
  import RecordMixin from '@/components/tools/RecordMixin.vue';
  import BookingForm from '@/components/pages/BookingForm.vue';

  export default {
    name: 'SaleEdit',
    mixins: [RecordMixin],
    props: ['id'],
    components: {
      BookingForm
    },
    data() {
      return {
        table: 'sales',
        limitSize: 15000000,
        attachs: {
          bookingform: { files: [] },
          entrances: { files: [] },
          flights: { files: [] },
          others: { files: [] },
          dayByDay: { files: [] },
          factSheet: { files: [] },
          tickets: { files: [] },
        },
        currentAttachs: {
          bookingform: [],
          entrances: [],
          flights: [],
          others: [],
          dayByDay: [],
          factSheet: [],
          tickets: [],
        },
        labelAttachs: {
          bookingform: 'Booking Form',
          entrances: 'Confirmaciones de proveedores',
          flights: 'Vuelos',
          others: 'Docs importantes',
          dayByDay: 'Dia a Dia',
          factSheet: 'FACT Sheet del pax',
          tickets: 'Entradas y Tickets',
        },
        isUploading: false,
        refCodeTimeout: null,
        viewExtra: false,
        computedForm: null,
        showBookingFormModal: false,
      };
    },
    async created () {
      this.ready = false;
      if (this.id) {
        await this.fetchRecord();
        await this.fetchAttachments(this.record?.Reference);
        await this.fetchBookingForm(this.record?.Reference);
      }
      this.ready = true;
    },
    methods: {
      checkFileSize(file) {
        return file.size <= this.limitSize;
      },
      uploadAttachs(event, folder) {
        let input = event.target;
        if (input.files) {
          let validFiles = [];
          for (let file of input.files) {
            if (this.checkFileSize(file)) {
              validFiles.push(file);
            } else {
              alert(`El archivo "${file.name}" excede el tamaño permitido de ${this.limitSize / 1000000} MB`);
            }
          }
          this.attachs[folder].files = validFiles;
        }
      },
      async uploadFiles(isNew) {
        try {
        if (!this.record.Reference) {
          this.$root.$refs.index.showNotification('Se requiere un código de referencia para subir archivos', 'danger');
          return;
        }

        // Check if there are any files to upload
        const hasFiles = Object.values(this.attachs).some(folder => folder.files.length > 0);
        if (!hasFiles) {
          return;
        }

        let formData = new FormData();
        let totalSize = 0;
        
        for (let folder in this.attachs) {
          for (let file of this.attachs[folder].files) {
            formData.append(folder, file);
            totalSize += file.size;
          }
        }

        // Check total size (e.g., 10MB limit)
        if (totalSize > 10 * 1024 * 1024) {
          this.$root.$refs.index.showNotification('El tamaño total de los archivos excede el límite permitido (10MB)', 'danger');
          return;
        }

          this.isUploading = true;
          let data = await api.post(`/api/upload_sales_attachs/${this.record.Reference}`, formData, {}, (error) => {
            this.$root.$refs.index.showNotification(error, 'danger')
          });
          
          if (!data || !data.uploaded_files) {
            this.$root.$refs.index.showNotification('Error al subir archivos: Respuesta inválida del servidor', 'danger');
            return;
          }

          await this.fetchAttachments(this.record?.Reference);
          
          this.$root.$refs.index.showNotification('Archivos subidos con éxito', 'success');

          // Clear the file inputs
          for (let folder in this.attachs) {
            this.attachs[folder].files = [];
          }

          if (!isNew) {
            // Instead of reload, refresh the data
            await this.fetchRecord();
          }

        } catch (error) {
          this.$root.$refs.index.showNotification(`Error al subir archivos: ${error}`, 'danger');
        } finally {
          this.isUploading = false;
        }
      },
      async handleSave(event) {
        this.$store.commit('setProcessing', true);
        try {
        const isNew = this.isNewRecord;        
        await this.saveRecord(event);
        await this.uploadFiles(isNew);
        } catch (error) {
          this.$root.$refs.index.showNotification(`Error al guardar: ${error}`, 'danger');
        } finally {
          this.$store.commit('setProcessing', false);
        }
      },
      async fetchAttachments(ref) {
        if (!ref) return;

        try {
          let data = await api.get(`/api/tpsql/list_sales_files/${ref}?folders=entrances,suppliers,others,bookingform,flights,dayByDay,factSheet,tickets`);
          for (let folder in this.currentAttachs) {
            this.currentAttachs[folder] = data.attachments[folder] || [];
          }
        } catch (error) {
          console.error('Error al obtener archivos:', error);
        }
      },
      async downloadFile(key, fileName) {
        try {
          await api.downloadFile('/api/tpsql/get_attach', { key }, fileName);
        } catch (error) {
          console.error('Error al descargar el archivo:', error);
          alert('Hubo un error al intentar descargar el archivo.');
        }
      },
      async deleteFile (keyattach,folder) {
        this.$store.commit('setProcessing', true);
        try {
        const response = await api.remove(`/api/tpsql/delete_attach?key=${keyattach}`, null, (error) => {
          this.$root.$refs.index.showNotification(error, 'danger')
        });
        if (response) {
          this.currentAttachs[folder] = this.currentAttachs[folder].filter(file => file.key !== keyattach);
          }
        } catch (error) {
          this.$root.$refs.index.showNotification(`Error al eliminar archivo: ${error}`, 'danger');
        } finally {
          this.$store.commit('setProcessing', false);
        }
      },
      async fetchBookingForm(reference) {
        if (!reference) return;
        try {
          let data = await api.get(`/api/bookingform/byreference/${reference}`);
          this.computedForm = data
        }
        catch {
          this.computedForm = null;
        }
      }, 
    }
  }
</script>

  
  <style scoped>
  .language-edit {
    margin: 0 auto;
    padding: 20px;
  }
  h3 {
    color: #2c3e50;
    margin-bottom: 15px;
  }

  h4 {
    color: #2c3e50;
    margin-bottom: 12px;
  }
  .attachments-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .attachment-card {
    background: #f5f5f5;
    padding: 10px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: background 0.3s;
  }

  .attachment-card:hover {
    background: #e0e0e0;
  }

  .file-icon {
    margin-right: 10px;
  }

  .file-name {
    color: #333;
  }
  </style>